import React from 'react';
import { Icon } from '@workboard/action-item';
import { useTranslation } from 'react-i18next';
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside';
import { IconStateWrapper } from '../../../components/sidePanel/components/iconWrapper';
import { DropdownListProps, ListCompProps, TItem } from '../../../types/automation.types';

const ListComp = ({
  typeId,
  name,
  label,
  values,
  srcVal,
  saveActivityTypeValue,
  hideShowListPopup
}: ListCompProps) => {
  const { t } = useTranslation();
  const [stateRef] = useOnClickOutside(() => {
    if (typeof hideShowListPopup === 'function') {
      hideShowListPopup();
    }
  });

  const onStateChanges = (item: TItem) => {
    saveActivityTypeValue(
      typeId,
      name,
      { label: item.label, value: item.value },
    );
  }

  const valuesArray = [{ value: '', label: t('None') }, ...values];

  return (
    <div ref={stateRef} className="statusListDivOuterWrap automationAttrWidth">
      <div className="attrLabel">{label}</div>
      {
        valuesArray.map((item: any) => (
          <div
            key={`${name}_${item.value}`}
            className="statusVal attrValFont clickable "
            data-value={item.value}
            onClick={() => onStateChanges(item)}
          >
            <IconStateWrapper isSourceFromAct={(srcVal == 'act')}>
              {
                item?.icons?.component
                  ? <Icon name={item?.icons?.component} width="16" height="16" />
                  : <span>&nbsp;</span>
              }
            </IconStateWrapper>
            <div className="displayInlineB">{item.label}</div>
          </div>
        ))
      }
    </div>
  );
}

export const DropdownList = ({
  name,
  label,
  values,
  value,
  srcVal,
  activityType,
  showListPopup,
  onShowListPopup,
  saveActivityTypeValue,
  hideShowListPopup
}: DropdownListProps) => {
  const { t } = useTranslation();
  const typeName = `type_${activityType}_${name}`;
  return (
    <div className="colmunAutoTitle" style={{ position: 'relative' }}>
      <div className="ColAutoName">{label}</div>
      <div
        className="ColAutoActionBorder"
        onClick={() => onShowListPopup(typeName)}
      >
        <span className="aiEffortValue">{value ?? t('None')}</span>
        <span className="colAutoDropImage" />
      </div>
      <div className="wsBoardAiAttrListDiv wsBoardAiAttr colAttrDiv">
        {showListPopup == typeName ? (
          <ListComp
            key={`${typeName}`}
            typeId={`type_${activityType}`}
            name={name}
            label={label}
            values={values}
            srcVal={srcVal}
            saveActivityTypeValue={saveActivityTypeValue}
            hideShowListPopup={hideShowListPopup}
          />
        ) : null}
      </div>
    </div>
  )
}
